import { render, staticRenderFns } from "./productImport.vue?vue&type=template&id=65a117dd&scoped=true"
import script from "./productImport.vue?vue&type=script&lang=js"
export * from "./productImport.vue?vue&type=script&lang=js"
import style0 from "./productImport.vue?vue&type=style&index=0&id=65a117dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a117dd",
  null
  
)

export default component.exports